import { SpaceAvailabilityRequestRecord } from "./space-availability-request-record";

export class SpaceAvailabilityRequest {
	spaces: SpaceAvailabilityRequestRecord[] | undefined;
}
